export default __webpack_public_path__ + "static/media/semper-musica-logo.376e8488.png";